import { render, staticRenderFns } from "./ProjectViewSidebarMessagesCard.vue?vue&type=template&id=26a113cc&scoped=true"
import script from "./ProjectViewSidebarMessagesCard.vue?vue&type=script&lang=ts"
export * from "./ProjectViewSidebarMessagesCard.vue?vue&type=script&lang=ts"
import style0 from "./ProjectViewSidebarMessagesCard.vue?vue&type=style&index=0&id=26a113cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a113cc",
  null
  
)

export default component.exports